import React from 'react';
import { TableRow } from '@mui/material';
import { ordinalList } from '../../utils/ordinal';
import { TSCell, TSTable } from '../ui/TableStructure';
import { useIsSmallDown } from '../../utils/responsive';


const BaseLeagueTable = ({leagueTable,variant,title}) => {
	const isSmallScreen=useIsSmallDown();
	const maxMinimalPositions=isSmallScreen?3:7;
	const maxPositionsPixelsMinimal=isSmallScreen?0:300;
	const maxPositionsPixelsStandard=400;
	const numPositions=(variant==="minimal")?(Math.min(leagueTable.length,maxMinimalPositions)):leagueTable.length;
	const maxPositionsPixels=(variant==="minimal"||variant==="form")?maxPositionsPixelsMinimal:maxPositionsPixelsStandard;
	const tableRows=leagueTable.map((p) => 
		<TableRow key={p.player}>
			<TSCell>{p.player}</TSCell>
			<TSCell>{p.played}</TSCell>
			{
				p.posCounts.map( (count,index) =>
					index<=numPositions && ((variant!=="form" && variant!=="minimal") || index>0) &&
						<TSCell sx={{width:`${(maxPositionsPixels/numPositions).toFixed(0)}px`}} key={index}>{count}</TSCell>
				)
			}
			<TSCell typo="body2">{p.total}</TSCell>
			{variant!=="form" && variant!=="minimal" && <TSCell>{p.discounted}</TSCell>}
			{variant!=="form" && <TSCell>
				{
						p.lowest2.length===0 ? '-'
					: p.lowest2.length===1 ? p.lowest2[0]
					: p.lowest2.join(',')
				}
			</TSCell>}
		</TableRow>
	);

	const headings=["Player","Played"];
	if (variant!=="form" && variant!=="minimal")
		headings.push("NoShows");
	headings.push(...ordinalList(numPositions));
	headings.push("Total");
	if (variant!=="form") {
		if (variant!=="minimal")
			headings.push("Discounted");
		headings.push("Low 2");
	}

	return(
		<TSTable title={title} headings={headings}>
			{tableRows}
		</TSTable>
	)	
	}

export default BaseLeagueTable;
